import * as C from "../constants";

import { get_logs } from "utils/http";
import { parseJSON } from "utils/misc";
import { logout } from "./auth";
import { history } from "../history";

export function getLogsRequest(){
    return {
        type: C.GET_LOGS_REQUEST,
    };
}

export function getLogsFailure(){
    return {
        type: C.GET_LOGS_FAILURE,
    };
}

export function getLogsSuccess(data){
    return {
        type: C.GET_LOGS_SUCCESS,
        payload: data,
    };
}

export function getLogs(token, fromTime, toTime, limit, machineId) {
    return function (dispatch) {
        dispatch(getLogsRequest());
        return get_logs(token, machineId, fromTime, toTime, limit)
            .then(parseJSON).then(response => {
                dispatch(getLogsSuccess(response))
            }).catch(error => {
                console.log(error);
                dispatch(getLogsFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}




// WEBPACK FOOTER //
// ./src/actions/logs.js